// ----------------------------------------------------------------------

export default function Button(theme) {
    return {
        MuiButton: {
            variants: [
                {
                    props: { variant: 'dashed' },
                    style: {
                        textTransform: 'none',
                        border: `2px dashed `,
                    },
                },
                {
                    props: { variant: 'dashed', color: 'secondary' },
                    style: {
                        border: `4px dashed `,
                    },
                },
            ],
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 0.5,
                        color: theme.palette.primary.contrastText,
                        backgroundColor: theme.palette.primary.main,
                    },
                },
            },
        },
    };
}
